import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {WorkplaceModel} from '@/libs/Api';
import {WorkplacesDataService} from '@/libs/workplaces/workplaces-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const workplacesStore = registerCrudStore<WorkplaceModel, WorkplaceModel>(BusinessModule.Workplace, new WorkplacesDataService());
